/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-bootstrap/tooltip/tooltip-container.component';
import * as i2 from 'ng2-bootstrap/tooltip/tooltip.config';
const styles_TooltipContainerComponent:any[] = ([] as any[]);
export const RenderType_TooltipContainerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_TooltipContainerComponent,data:{}});
export function View_TooltipContainerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),0,'div',[['class','tooltip-arrow']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class','tooltip-inner']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵncd((null as any),0),(_l()(),i0.ɵted((null as any),['\n    ']))],(null as any),
      (null as any));
}
export function View_TooltipContainerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'bs-tooltip-container',
      [['role','tooltip']],[[8,'className',0],[2,'show',(null as any)]],(null as any),
      (null as any),View_TooltipContainerComponent_0,RenderType_TooltipContainerComponent)),
      i0.ɵdid(4243456,(null as any),0,i1.TooltipContainerComponent,[i2.TooltipConfig],
          (null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = ((('tooltip in tooltip-' + i0.ɵnov(_v,1).placement) + ' ') + i0.ɵnov(_v,
        1).placement);
    const currVal_1:boolean = !i0.ɵnov(_v,1).isBs3;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const TooltipContainerComponentNgFactory:i0.ComponentFactory<i1.TooltipContainerComponent> = i0.ɵccf('bs-tooltip-container',
    i1.TooltipContainerComponent,View_TooltipContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL3Rvb2x0aXAvdG9vbHRpcC1jb250YWluZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9ub2RlX21vZHVsZXMvbmcyLWJvb3RzdHJhcC90b29sdGlwL3Rvb2x0aXAtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL3Rvb2x0aXAvdG9vbHRpcC1jb250YWluZXIuY29tcG9uZW50LmQudHMuVG9vbHRpcENvbnRhaW5lckNvbXBvbmVudC5odG1sIiwibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL3Rvb2x0aXAvdG9vbHRpcC1jb250YWluZXIuY29tcG9uZW50LmQudHMuVG9vbHRpcENvbnRhaW5lckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgY2xhc3M9XCJ0b29sdGlwLWFycm93XCI+PC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cInRvb2x0aXAtaW5uZXJcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9kaXY+XG4gICAgIiwiPGJzLXRvb2x0aXAtY29udGFpbmVyPjwvYnMtdG9vbHRpcC1jb250YWluZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLDJDQUNJO01BQUE7TUFBQSw0Q0FBaUM7TUFDakM7VUFBQTthQUEyQixrQkFBK0I7Ozs7b0JDRjlEO01BQUE7TUFBQTthQUFBO1VBQUE7SUFBQTtRQUFBO0lBQUE7SUFBQSxXQUFBLG1CQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./Client/$$_gendir/~/ng2-bootstrap/tooltip/tooltip-container.component.ngfactory.ts